import "@/App.css";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Academics } from "@/components/Academics";
import { Marquee } from "@/components/Marquee";
import { Gallery } from "@/components/Gallery";
import { Admissions } from "@/components/Admissions";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <SmoothScroll>
      <div className="App grain">
        <Header />
        <main>
          <Hero />
          <About />
          <Academics />
          <Marquee />
          <Gallery />
          <Admissions />
          <Contact />
        </main>
        <Footer />
        <Toaster position="top-center" />
      </div>
    </SmoothScroll>
  );
}

export default App;
